import moment from "moment"
import { DeviceType, UserMembershipRequest } from "../services/ntuc/memberService/oaMembership"
import { getSignupFee, MetadataStatus, OrderRequest, postCreateOrder, ServiceType, SignupFees } from "../services/ntuc/memberService/payment"
import { getInitiatePayment } from "../services/ntuc/paymentService/payment"
import { NEW_COMPANY_CODE } from "../services/ntuc/userService/company"
import { SignupState } from "../store/signup/SignupState"

export const getSignupRequest = (state: SignupState): UserMembershipRequest => {
    const { personalDetail, addressAndEmploymentDetail, bankDetail, referralDetail, campaign } = state
    const dob = moment(personalDetail.dateOfBirth).format(`YYYY-MM-DD`)
    return {
        user: {
            status: `DRAFT`,
            race: personalDetail.race.code,
            nricFin: personalDetail.nric,
            name: personalDetail.name,
            mobileNumber: personalDetail.mobileNumber,
            maritalStatus: personalDetail.maritalStatus.code,
            highestEducationLevel: personalDetail.educationalStatus.code,
            gender: personalDetail.gender,
            email: personalDetail.email,
            dob: dob,
            occupationalGroup: addressAndEmploymentDetail.occupationalGroup.code,
            occupation: addressAndEmploymentDetail.jobTitle,
            monthlyGrossSalary: Number(addressAndEmploymentDetail.monthlySalary.code),
            company: {
                name: addressAndEmploymentDetail.companyName.name,
                code: addressAndEmploymentDetail.companyName.code === NEW_COMPANY_CODE ? undefined : addressAndEmploymentDetail.companyName.code,
                businessNature: addressAndEmploymentDetail.companyName.businessNature,
            },
            address: {
                residentialStatus: personalDetail.residentialStatus.code,
                postalCode: addressAndEmploymentDetail.postalCode,
                blockHSENo: addressAndEmploymentDetail.houseNumber,
                floor: addressAndEmploymentDetail.floorNumber,
                unit: addressAndEmploymentDetail.unitNumber,
                street: addressAndEmploymentDetail.streetName,
                buildingName: addressAndEmploymentDetail.buildingName,
            },
            bankName: bankDetail.bankName.value,
            bankCode: bankDetail.bankName.code,
            bankAccountNumber: bankDetail.accountNumber,
        },
        membership: {
            campaignCode: campaign?.code,
            optInNebo: false,
            deviceType: DeviceType.WEB,
            nameOnCard: personalDetail.cardName,
            referralCode: referralDetail.referralCode,
            recruiterCode: referralDetail.recruiterCode,
        },
    }
}

export const payMembershipSignupFees = (membershipId: number): Promise<void> => {
    return new Promise((resolve, reject) => {
        getSignupFees(membershipId)
            .then((fees) => {
                const order = createSignupOrder(membershipId, fees)

                proceedToPayment(order)
                    .then(resolve)
                    .catch(reject)
            })
            .catch(reject)
    })
}

const getSignupFees = async (membershipId: number): Promise<SignupFees> => {
    return new Promise((resolve, reject) => {
        getSignupFee(membershipId)
            .then(response => {
                if (response.data.metadata.status === MetadataStatus.SUCCESS) {
                    resolve(response.data.content)
                } else {
                    reject()
                }
            })
            .catch(reject)
    })
}

const createSignupOrder = (membershipId: number, fees: SignupFees): OrderRequest => {
    return {
        feeType: fees.feeType,
        endDate: fees.endDate,
        startDate: fees.startDate,
        serviceType: ServiceType.SIGN_UP,
        noOfMonths: fees.month,
        amount: `${fees.amount}`,
        isOneTimePayment: true,
        isRecurringPayment: true,
        membershipId: membershipId,
        deviceType: DeviceType.WEB,
    }
}

const proceedToPayment = (order: OrderRequest): Promise<void> => {
    return new Promise((resolve, reject) => {
        postCreateOrder(order)
            .then(response => response.data.content.clientOrderId)
            .then(redirectToPaymentGateway)
            .then(resolve)
            .catch(reject)
    })
}

const redirectToPaymentGateway = (clientOrderId: string) => {
    window.location.replace(getInitiatePayment(clientOrderId))
}